module.exports = __webpack_public_path__ + "img/champ_de_tournesols-mobile.d8215d63.webp";